<template>
  <a-drawer
    v-model:visible="visible"
    title="Selecciona tus filtros personalizados"
    destroy-on-close
    placement="right"
    width="480"
    keyboard
    :body-style="{ padding: 0 }"
    @close="handleCancel"
  >
    <custom-scrollbar height="calc(100vh - 72px - 48px)">
      <p class="text">
        Segmenta tu estrategia con los datos de tus filtros personalizados que creaste en la sección
        de plantillas.
      </p>

      <custom-collapser
        v-if="!!filters"
        :is-expanded="isClientsExpanded"
        title="Filtros personalizados de contactos"
      >
        <a-form layout="vertical">
          <custom-filters-input
            v-for="item in filters.custom_clients"
            :key="item.name"
            :item="item"
            @change="handleChangeClients"
          />
        </a-form>
      </custom-collapser>
      <custom-collapser
        v-if="hasProducts"
        :is-expanded="isProductsExpanded"
        title="Filtros personalizados de productos"
      >
        <a-form layout="vertical">
          <custom-filters-input
            v-for="item in filters.custom_products"
            :key="item.name"
            :item="item"
            @change="handleChangeProduct"
          />
        </a-form>
      </custom-collapser>
    </custom-scrollbar>

    <div class="footer">
      <div class="footer__display">
        {{ getClientsQuantityText(calculations) }}
      </div>
      <a-button class="footer__button" @click="handleCancel"> Cancelar </a-button>
      <a-button type="primary" :disabled="!hasClients" @click="handleOk"> Aceptar </a-button>
    </div>
  </a-drawer>
</template>

<script>
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import CustomCollapser from "@/app/shared/components/organisms/CustomCollapser.vue";
import CustomFiltersInput from "@/app/strategies/components/drawers/CustomFiltersInput.vue";

export default {
  components: {
    CustomScrollbar,
    CustomCollapser,
    CustomFiltersInput,
  },
  props: {
    value: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      filters: null,
    };
  },
  computed: {
    calculations() {
      return {
        clients: this.filters?.number_clients,
        phones: this.filters?.number_phones,
      };
    },
    numberClients() {
      return this.filters?.number_clients || 0;
    },
    hasClients() {
      return this.numberClients !== 0;
    },
    hasProducts() {
      return this.filters?.has_products;
    },
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      },
    },
    isClientsExpanded() {
      return this.filters?.custom_clients?.some((custom) => custom?.values?.length !== 0);
    },
    isProductsExpanded() {
      return this.filters?.custom_products?.some((custom) => custom?.values?.length !== 0);
    },
  },
  methods: {
    getClientsQuantityText(calculations) {
      const clients = calculations.clients;
      const phones = calculations.phones;

      if (!phones) return `${clients} contactos detectados`;
      return `${clients} contactos y ${phones} teléfonos detectados`;
    },
    initDrawer() {
      const filters = this.$store.getters["getStrategyFilters"];
      this.filters = JSON.parse(JSON.stringify(filters));
    },
    handleOk() {
      this.$store.dispatch("setStrategyFiltersState", this.filters);
      this.visible = false;
    },
    handleCancel() {
      this.visible = false;
    },
    async handleChangeClients(event) {
      this.filters.custom_clients.forEach((item) => {
        if (item.title == event.title) {
          item.values = event.value;
        }
      });
      const calculations = await this.$store.dispatch("fetchStrategyCalcutations", this.filters);
      this.filters = { ...this.filters, ...calculations };
    },
    async handleChangeProduct(event) {
      this.filters.custom_products.forEach((item) => {
        if (item.title == event.title) {
          item.values = event.value;
        }
      });
      const calculations = await this.$store.dispatch("fetchStrategyCalcutations", this.filters);
      this.filters = { ...this.filters, ...calculations };
    },
  },
};
</script>

<style lang="sass" scoped>
.text
  padding: 12px 24px
  margin: 0

.footer
  display: flex
  align-items: center
  justify-content: flex-end
  margin-top: 8px
  padding: 12px 16px
  border-top: $border-normal

  &__display
    width: 100%
    font-size: 12px
    color: $gray-7

  &__button
    margin-right: 12px
</style>
